import React, { useEffect } from 'react';
import { NavHeader } from '../PageElements/NavHeader';
import Header from '../PageElements/Header';
import Footer from '../PageElements/Footer';
import '../CSS/Industry.css';
import ScrollReset from '../Tools/ScrollReseter';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import HorizontalLine from '../PageElements/HorizontalLine';

export default function Industry() {
  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
      <ScrollReset />
      <div className='wrapper'>
        <NavHeader maxScroll={200} windowWidth={windowWidth} />
        <Header imageURL={'Images/Industry.png'} title={'Industry'} titleSize={windowWidth > 750 ? 48 : 28} windowWidth={windowWidth} />
        <Content windowWidth={windowWidth} />
        <Footer imageURL={'Images/Industry.png'} windowWidth={windowWidth} />
      </div>
    </>
  );
}

function Content({windowWidth}) {
  return (
    <>
      <div
        className='content'
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          position: 'relative',
          gap: '50px',
          height: '400px',
          width: '100%',
          padding: '0',
        }}>
        <div className='topImage'>
          <svg width='1' height='120' viewBox='0 0 1 120' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M0.5 0.231812V119.768' stroke='url(#paint0_linear_230_561)' />
            <defs>
              <linearGradient id='paint0_linear_230_561' x1='0.5' y1='0.306803' x2='26.0072' y2='5.7883' gradientUnits='userSpaceOnUse'>
                <stop stopColor='#BC9C4E' />
              </linearGradient>
            </defs>
          </svg>

          <img
            className='headerImage'
            alt=''
            height={380}
            width={800}
            src='Images/WebsiteCoverImage.png'
            style={{ maxWidth: '800px', minWidth: '200px', height: 'auto', width: '100%' }}
          />

          <svg width='1' height='120' viewBox='0 0 1 120' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M0.5 0.231812V119.768' stroke='url(#paint0_linear_230_561)' />
            <defs>
              <linearGradient id='paint0_linear_230_561' x1='0.5' y1='0.306803' x2='26.0072' y2='5.7883' gradientUnits='userSpaceOnUse'>
                <stop stopColor='#BC9C4E' />
              </linearGradient>
            </defs>
          </svg>
        </div>

        <div style={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'row' }}>
          <div
            style={{
              width: windowWidth > 970 ? '950px' : '80%',
              gap: '8px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'start',
              flexDirection: 'column',
            }}>
            <h1 style={{ fontSize: '24px' }}>Shaping the Future of Market Intelligence</h1>

            <p>
              Sókn Engineering is revolutionizing the trading and commodities industry with cutting-edge AI-driven predictive analytics. By harnessing
              proprietary mathematics and real-time market intelligence, we provide unparalleled accuracy in price forecasting—down to the half-penny.
              Our technology empowers traders, funds, and commodity producers to act ahead of the market, optimizing profitability while mitigating
              risk. With validated performance and a proven track record, Sókn is setting new industry standards, transforming how financial
              instruments and commodities are traded globally.
            </p>
          </div>
        </div>

        <HorizontalLine />

        <Swiper
          style={{ width: '100%', height: '600px', backgroundColor: '#F3F3F3' }}
          loop={true}
          navigation
          pagination={{
            clickable: true,
            renderBullet: function (index, className) {
              return '<span class="' + className + '">' + (index + 1) + '</span>';
            },
          }}
          modules={[Navigation, Pagination]}>
          <SwiperSlide>
            <Section bracketHeight={50}>
              <div
                style={{
                  width: '728px',
                  height: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'flex-start',
                  flexDirection: 'column',
                  gap: '10px',
                }}>
                <p style={{ fontFamily: 'Jura', fontSize: '24px', color: 'var(--Complementary)' }}>
                  <b>The Problem:</b> Outdated Commodity Trading Models
                </p>

                <ul>
                  <li>
                    <b>Inaccurate Predictions: </b>Traditional models rely on historical data, missing real-time market signals and leading to poor
                    decisions.
                  </li>
                  <li>
                    <b>High Risk Exposure:</b> Traders face volatile markets without accurate predictive tools, resulting in reactive strategies.
                  </li>
                  <li>
                    <b>Lost Revenue for Producers:</b> Commodity producers often settle for broad pricing windows, sacrificing potential profit.
                  </li>
                </ul>

                <p>Market makers dominate price movements, and outdated models leave traders, funds, and producers struggling to keep up.</p>
              </div>
            </Section>
          </SwiperSlide>
          <SwiperSlide>
            <Section bracketHeight={40}>
              <div
                style={{
                  width: '728px',
                  height: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'flex-start',
                  flexDirection: 'column',
                  gap: '10px',
                }}>
                <p style={{ fontFamily: 'Jura', fontSize: '24px', color: 'var(--Complementary)' }}>
                  <b>The Solution:</b> AI-Powered Precision from Sókn Engineering
                </p>

                <ul>
                  <li>
                    <b>Real-Time Intelligence: </b>Tracks market maker behaviors live, ensuring decisions are based on current market intent.
                  </li>
                  <li>
                    <b>Penny-Perfect Predictions: </b> Provides price forecasts accurate to fractions of a dollar.
                  </li>
                  <li>
                    <b>Versatile Applications: </b> Supports fund management, proprietary trading, and commodity pricing optimization.
                  </li>
                </ul>

                <p>Our AI models decode algorithmic signals in real-time, giving clients a competitive edge.</p>
              </div>
            </Section>
          </SwiperSlide>
          <SwiperSlide>
            <Section bracketHeight={70}>
              <div
                style={{
                  width: '728px',
                  height: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'flex-start',
                  flexDirection: 'column',
                  gap: '10px',
                }}>
                <p style={{ fontFamily: 'Jura', fontSize: '24px', color: 'var(--Complementary)' }}>
                  <b>Sókn Engineering</b> vs. Traditional Market Methods
                </p>

                <table>
                  <thead>
                    <tr>
                      <th>Feature</th>
                      <th>Sókn Engineering</th>
                      <th>Traditional Models</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Approach</td>
                      <td>Real-time market intent tracking</td>
                      <td>Historical data analysis</td>
                    </tr>
                    <tr>
                      <td>Accuracy</td>
                      <td>Cents-accurate price points</td>
                      <td>Broad, less precise predictions</td>
                    </tr>
                    <tr>
                      <td>Technology</td>
                      <td>AI signal processing</td>
                      <td>Statistical assumptions</td>
                    </tr>
                    <tr>
                      <td>Flexibility</td>
                      <td>Works for funds, producers, and multiple assets</td>
                      <td>Single user type, limited scope</td>
                    </tr>
                    <tr>
                      <td>Revenue Streams</td>
                      <td>Licensing, management, consulting</td>
                      <td>Performance-based fees only</td>
                    </tr>
                    <tr>
                      <td>Risk Management</td>
                      <td>Low regulatory exposure, diverse income</td>
                      <td>High regulatory burden</td>
                    </tr>
                  </tbody>
                </table>

                <p>We leverage real-time intent tracking, offering superior accuracy and flexibility.</p>
              </div>
            </Section>
          </SwiperSlide>
          <SwiperSlide>
            <Section bracketHeight={50}>
              <div
                style={{
                  width: '728px',
                  height: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'flex-start',
                  flexDirection: 'column',
                  gap: '10px',
                }}>
                <p style={{ fontWeight: 'bold', fontFamily: 'Jura', fontSize: '24px', color: 'var(--Complementary)' }}>Why Sókn Engineering Excels</p>

                <ul>
                  <li>
                    <b>Modular Calculus: </b>Enables chaos modeling for unmatched prediction accuracy.
                  </li>
                  <li>
                    <b>Lagertha Platform:</b> Fully autonomous, self-learning AI for efficient, cost-effective trading.
                  </li>
                  <li>
                    <b>Proven Results:</b> Demonstrated significant net return on investment in live trials, with minimal loss exposure.
                  </li>
                  <li>
                    <b>Broad Reach:</b> Supports commodities, currencies, and blockchain assets.
                  </li>
                </ul>

                <p>
                  Sókn Engineering transforms market inefficiencies into profitable opportunities with unmatched accuracy, reduced risk, and
                  cutting-edge technology.
                </p>
              </div>
            </Section>
          </SwiperSlide>
        </Swiper>

        <HorizontalLine />

        <h1 style={{ fontSize: '20px', marginBottom: '30px' }}>Knowing Tomorrow... Today.</h1>
      </div>
    </>
  );
}

function Section({ bracketHeight = 80, children }) {
  return (
    <SwiperSlide>
      <div className='contentSection'>
        <svg
          className='hide750'
          width='86'
          height={`${bracketHeight}%`}
          viewBox='0 0 86 229'
          preserveAspectRatio='none'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'>
          <path
            vectorEffect='non-scaling-stroke'
            d='M86 228H21C9.9543 228 0.999998 219.046 0.999998 208V21C0.999998 9.95431 9.9543 1 21 1H86'
            stroke='url(#paint0_linear_237_858)'
            strokeWidth='2'
          />
          <defs>
            <linearGradient id='paint0_linear_237_858' x1='1.00001' y1='114.395' x2='86' y2='115' gradientUnits='userSpaceOnUse'>
              <stop stopColor='#5472B8' />
              <stop offset='1' stopColor='#5472B8' stopOpacity='0' />
            </linearGradient>
          </defs>
        </svg>

        {children}

        <svg
          className='hide750'
          width='86'
          height={`${bracketHeight}%`}
          viewBox='0 0 86 229'
          preserveAspectRatio='none'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'>
          <path
            vectorEffect='non-scaling-stroke'
            d='M0 228H65C76.0457 228 85 219.046 85 208V21C85 9.95431 76.0457 1 65 1H0'
            stroke='url(#paint0_linear_237_856)'
            strokeWidth='2'
          />
          <defs>
            <linearGradient id='paint0_linear_237_856' x1='85' y1='114.395' x2='-0.225464' y2='114.395' gradientUnits='userSpaceOnUse'>
              <stop stopColor='#5472B8' />
              <stop offset='1' stopColor='#5472B8' stopOpacity='0' />
            </linearGradient>
          </defs>
        </svg>
      </div>
    </SwiperSlide>
  );
}
